import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROLES } from "@/common/permissions";
import { useIsPermitted } from "@/hooks/useIsPermitted";

export interface SidebarNavItemProps {
  href?: string;
  name: string;
  onClick?: () => void;
  onClose?: () => void;
  className?: string;
  role?: ROLES;
  disabled?: boolean;
}

export function SidebarNavItem({ 
  href = "", 
  name, 
  onClick, 
  onClose, 
  className, 
  role,
  disabled = false 
}: SidebarNavItemProps) {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = location.pathname === href;
  const isPermitted = useIsPermitted(role || ROLES.WAITER);
  
  // Combine external disabled state with permission-based disabled state
  const isDisabled = disabled || !isPermitted;

  const handleClick = () => {
    if (!isDisabled) {
      onClose?.();
      onClick?.();
    }
  };

  const Content = () => t(name);

  if (!isPermitted) {
    return null;
  }

  return (
    <Button
      variant="link"
      size="sm"
      className={cn(
        className,
        "w-full flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium hover:bg-dark hover:text-dark-foreground",
        "hover:bg-dark hover:text-dark-foreground",
        "transition-colors",
        "text-left",
        "justify-start",
        "disabled:bg-transparent",
        isActive && "bg-dark text-dark-foreground"
      )}
      disabled={isDisabled}
    >
      {!isDisabled && href ? (
        <Link to={href} onClick={handleClick} >
          <Content />
        </Link>
      ) : (
        <div onClick={handleClick}>
          <Content />
        </div>
      )}
    </Button>
  );
} 